import { render } from "./MdListDetailPage.vue?vue&type=template&id=5e5c2629&scoped=true"
import script from "./MdListDetailPage.vue?vue&type=script&lang=js"
export * from "./MdListDetailPage.vue?vue&type=script&lang=js"

import "./MdListDetailPage.vue?vue&type=style&index=0&id=5e5c2629&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5c2629"]])

export default __exports__